<template>
  <div>
    <h2>404</h2>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped></style>
